import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Injectable, Component, OnInit } from '@angular/core';
import { Observable,Subscription } from 'rxjs';
import {Router,CanActivate,ActivatedRouteSnapshot,RouterStateSnapshot} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable()
  
  @Component({
  selector: 'app-timer',
  template: '{{ticks}}',
})
  export class timerComponent implements OnInit {
    ngOnInit(): void {
      throw new Error("Method not implemented.");
    }

  constructor(private webService: CallBackEndService,private router:Router,private toastr: ToastrService) {
  }
  ticks: number;
start: number=0;
stop: number=1000;
 sub: Subscription; 
   startTimer() {
     const request: IbRequest = new IbRequest();
    const response: IbResponse = null;
    let number = Observable.timer(this.start, this.stop);
    this.sub = number.subscribe(
        t => {
            this.ticks = t;
         //  console.log("time count "+this.ticks)
        
          // if(this.ticks==1800)
          if(this.ticks==1800)
            {
              this.toastr.error("Login Again", 'Your Session Is Expired .',{'easeTime':0,'closeButton':true,'disableTimeOut':true});
              request.param1 =sessionStorage.getItem('token'); 
              request.param2 =sessionStorage.getItem('storedUserName');
             this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
        if (data !== null && data.status === 'S200') {
         console.log('logout yuiyu'+data.status);
          sessionStorage.removeItem('currentUser');
      this.router.navigate(['/login'])
          this.sub.unsubscribe();
          
      }else{
        
      }
    });
          }
        }
    );
}
  resetTimer(){
     this.sub.unsubscribe();
  this.startTimer();
}
  
  stopTimer(){
     this.sub.unsubscribe();
  
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/cheque-book-request/timerComponent.ts